export const FETCH_WIFI_ENTRIES = 'FETCH_WIFI_ENTRIES'
export const WIFI_SUCCESS = 'WIFI_SUCCESS'
export const RESET_STATE = 'RESET_STATE'

export type WifiEvent = {
  channelNumber: Array<string>
  signal: Array<string>
  eventTs: string
  frequency: Array<string>
}

export type NormalizedWifiEvent = {
  channelNumber: number
  signal: number
  eventTs: string
  frequency: number
}

export type WifiDashboardsAPIResponse = {
  householdId: string
  insertTs: string
  wifiEvent: Array<WifiEvent>
  latestWifiEventTs: string
  opcoId: string
  deviceId: string
  customWfSigMin: string
  wifiScore: string
  customWfSigMax: string
}

export type SortedWifiEvents = {
  [k: string]: WifiEvent | undefined
}

export type MappedWifiEvents = {
  [k: string]: NormalizedWifiEvent | undefined
}

export type WifiEventPayload = {
  type: string
  payload: WifiDashboardsAPIResponse
}

export type WifiState = {
  events: MappedWifiEvents
  minSignal: number | null
  maxSignal: number | null
  latestSignal: number | null
  score: number | null
}
